import React, { useState, useMemo, useContext, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useDidMount } from '../../utils/hooks';
import { url } from '../../utils/variables';
import { getDirection, pexios, toast, uploadImages } from '../../utils/functions';
import { setUser } from '../../redux/actions';
import ImagePickerModal from '../../components/master/ImagePickerModal';
import Input from '../../components/master/Input';
import DatePicker from '../../components/master/DatePicker';
import ExpertDocs from '../../components/pages/profileEdit/ExpertDocs';
import UserCarInfoEdit from '../../components/pages/profileEdit/UserCarInfoEdit';
import ExpertInfoEdit from '../../components/pages/profileEdit/ExpertInfoEdit';
//import UserDocs from '../../components/pages/profileEdit/UserDocs';
import defaultProfile from '../../assets/images/user-icon2.png';
import MellatLogo from '../../assets/images/icons/logo-mellat.png'
import { useTranslation } from 'react-i18next';
import Modal from '../../components/master/Modal';
import { TitleContext } from '../../App';
import Camera from '../../assets/images/icons/camera.png';
import Profile from '../../assets/images/icons/orange-profile.png'
import CarInfo from '../../assets/images/icons/car-info-orange.png'
import InsuranceInfo from '../../assets/images/icons/insurance-info-orange.png'
import Files from '../../assets/images/icons/orange-files.png'
import { compileAsync } from 'sass';


export default function EditProfile() {

    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();

    const [data, setData] = useState({});
    const [componentLoader, setComponentLoader] = useState(true);
    const [loading, setLoading] = useState(false);
    const [step,setStep] =useState(0);
    const [loadPage,setLoadPage] = useState(false)
    // const {setTitle} =useContext(TitleContext);
    // useEffect(()=>{
    //     setTitle('پروفایل')
    // },[])

    const avatar = useMemo(() => {
        return data.avatar
            ? `${url}/files?uid=${data.avatar.uid}&width=200&height=200`
            : defaultProfile;
    }, [data.avatar]);

    useDidMount(() => {
        setLoadPage(true)
        pexios('api/v2/get_user').then(res => {
            // const data = JSON.parse(res.data.data);
            const data = res.data.data;
            setData({
                ...res.data.user_car_info,
                ...res.data,
                ...(res.data.type === 'expert' && {
                    address: data.address || '',
                    maritalStatus: data.marital_status || '',
                    emergencyPhone: data.emergency_phone || '',
                }),
                plate_type: res.data?.user_car_info?.plate_type || 'car',
            });
            setComponentLoader(false);
            setLoadPage(false)
        });
    });

    function changeData(value, name) {
        setData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    }

    function uploadAvatar(image, name, done) {
        uploadImages({
            id: data.id,
            type: 'user',
            name,
            image,
            done,
            callback: (img) => {
                setData(prevState => ({
                    ...prevState,
                    avatar: img,
                }));
            },
        });
    }

    function submit() {
        if(data.type === 'expert' && data.fix_change){
            
            toast(t('Unchangable info alert'), 'error');
            return;
        }
        // if (data.type === 'expert' && data.sheba?.length !== 10) {
        //     toast(t('Enter the correct account id'), 'error');
        //     return;
        // }
        setLoading(true);
        pexios('api/v2/update_user', 'post', data)
            .then(res => {
                dispatch(setUser(res.data));
                toast(t('Profile edited successfully'));
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
            });
    }
    function NextStep() {
        if(data.type === 'user')
            setStep(prevState => prevState +1)
        else {
            setStep(prevState => prevState +2)
            submit()
        }
    }

    return (
        <>
        {loadPage &&
                <Modal visible={loadPage}>
                    <div className='loader-modal'>
                        <i className='fas fa-spinner fa-spin'/>
                    </div>
                </Modal>
            }
        {
        !componentLoader && data.type === 'user' &&
            <div className="profile-steps" dir={getDirection(i18n.language) === 'rightToLeft' ? 'rtl' : 'ltr'}>
                {/* <span className={`glider ${step === 0 ? 'first': step === 1 ? 'second' : 'third'}`}/> */}
                    <span className={`b-bl-sharp ${step === 0 ? 'active' : ''}`} onClick={()=> setStep(0)} >{t('User info')} <img src={Profile}/></span>
                    <span className={`b-bl-sharp ${step === 1 ? 'active' : ''}`} onClick={()=> setStep(1)} >{t('Car info')} <img style={{width: '35px'}} src={CarInfo}/></span>
                    <span className={`b-bl-sharp ${step === 2 ? 'active' : ''}`} onClick={()=> setStep(2)}>{t('Insurance info')} <img src={InsuranceInfo}/></span>               
            </div>
        } 
        {
        !componentLoader && data.type === 'expert' &&
            <div className="profile-steps" dir={getDirection(i18n.language) === 'rightToLeft' ? 'rtl' : 'ltr'}>
                {/* <span className={`glider ${step === 0 ? 'first': step === 1 ? 'second' : 'third'}`}/> */}
                <span className={`b-bl-sharp ${step === 0 ? 'active' : ''}`} onClick={()=> setStep(0)} >مشخصات کارشناس <img src={Profile}/></span>
                {/* <span className={`${step === 1 ? 'active' : ''}`} onClick={()=> setStep(1)} >{t('Car info')}</span> */}
                <span className={`b-bl-sharp ${step === 2 ? 'active' : ''}`} onClick={()=> setStep(2)}>تصاویر مدارک <img src={Files}/></span>
            </div>
        }
        <div className='content profile'>
        {!loadPage && 
        <>
            {
                !componentLoader && step === 0 && 
                <div className={`${step === 0 ? 'profile-step active' : 'profile-step'}`}>
                    <div className='avatar'>               
                        <ImagePickerModal
                            renderBtn={
                                
                                <div
                                    className='image'
                                    style={{backgroundImage: `url('${avatar}')`}}
                                >
                                    <span className='badge'>
                                        <img src={Camera} alt='camera'/>
                                    {/* <i className='fas fa-camera'/> */}
                                    </span>
                                    </div>
                            
                            }
                            upload={(image, done) => uploadAvatar(image, 'avatar', done)}
                            croppable={true}
                        />
                    </div>
                    <div className={`row ${getDirection(i18n.language) ==='rightToLeft'?' text-right':'text-left'}`}>
                        <Input
                            label={t('First name')}
                            value={data.fname}
                            isLTR={getDirection(i18n.language) === 'leftToRight'}
                            disabled={true}
                            //dir='rtl'
                            //mode='numeric'
                            //onChange={value => changeData(value, 'nationalCode')}
                            name='fname'
                        />
                        <Input
                            label={t('Last name')}
                            value={data.lname}
                            isLTR={getDirection(i18n.language) ==='leftToRight'}
                            disabled={true}
                            //dir='rtl'
                            //mode='numeric'
                            //onChange={value => changeData(value, 'nationalCode')}
                            name='lname'
                        />
                    </div>
                    <div className={`${getDirection(i18n.language) ==='rightToLeft'?' text-right':'text-left'} mr5 ml5 bank-input`}>
                        <Input
                            label={t('Shaba number')}
                            // label={data.type === 'expert' ? t('Hesab number') : t('Shaba number')}
                            value={data.sheba}
                            hasIcon
                            isLTR
                            mode='numeric'
                            required={data.type === 'expert'}
                            onChange={value => changeData(value, 'sheba')}
                            disabled={data.fix_change}
                            maxLength={24}
                            name="sheba"
                        >
                            
                            {/* {data.type === 'expert' && <img className='bank-logo' src={MellatLogo} alt="mellat-logo"/>} */}
                            {
                                // data.type === 'user' &&
                                <i style={{top: '5px'}}>IR-</i>
                            }
                        </Input>
                    </div>
                    <div className={`row ${getDirection(i18n.language) ==='rightToLeft'?' text-right':'text-left'}`}>
                        <Input
                            label={t('National ID')}
                            value={data.national_code}
                            isLTR
                            //dir='rtl'
                            mode='numeric'
                            name='nationalId'
                            maxLength={10}
                            onChange={value => changeData(value, 'national_code')}
                            disabled={data.fix_change}
                        />
                        <DatePicker
                            label={t('Birth date')}
                            isBirthDate
                            rtl
                            value={data.birth_date}
                            onChange={date => changeData(date, 'birth_date')}
                            disabled={data.fix_change}
                        />
                    </div>
                </div>
                    // <div className='row text-right'>
                    //     <Input
                    //         label={data.type === 'expert' ? 'شماره حساب ملت' : 'شماره شبا مالک'}
                    //         value={data.sheba}
                    //         hasIcon={data.type === 'user'}
                    //         isLTR
                    //         mode='numeric'
                    //         required={data.type === 'expert'}
                    //         onChange={value => changeData(value, 'sheba')}
                    //     >
                    //         {
                    //             data.type === 'user' &&
                    //                 <i style={{top: '5px'}}>IR-</i>
                    //         }
                    //     </Input>
                    //     <Input
                    //         label='کد ملی'
                    //         value={data.national_code}
                    //         isLTR
                    //         mode='numeric'
                    //         onChange={value => changeData(value, 'nationalCode')}
                    //     />
                    //     <DatePicker
                    //         label='تاریخ تولد'
                    //         isBirthDate
                    //         value={data.birth_date}
                    //         onChange={date => changeData(date, 'birth_date')}
                    //     />
                    //     {
                    //         data.type === 'expert' ?
                    //             <ExpertInfoEdit
                    //                 data={data}
                    //                 changeData={changeData}
                    //             /> :
                    //             <UserCarInfoEdit
                    //                 data={data}
                    //                 changeData={changeData}
                    //             />
                    //     }
                    // </div>
            }
            {
                !componentLoader &&
                <div className={`row ${getDirection(i18n.language) ==='rightToLeft'?' text-right':'text-left'}`}>
                    {
                            data.type === 'expert'  ?
                                <ExpertInfoEdit
                                    data={data}
                                    changeData={changeData}
                                    step={step}
                                /> :
                                <UserCarInfoEdit
                                    data={data}
                                    changeData={changeData}
                                    ///
                                    step={step}
                                />
                        }
                    </div>
            }
            {
                data.type === 'expert' && step === 2 &&
                    <ExpertDocs
                        data={data}
                    />
            }
            {step !== 2 && 
            // data.type === 'user' && 
            (
                <div className='text-center'>
                <button className={`btn btn-circle btn-white-purple w-50 mt30 ${step !== 2 ? 'profile-step active' : 'profile-step'}`} disabled={loading && 'disabled'}
                        onClick={NextStep}>
                    {
                        loading ?
                            <i className='fas fa-spinner fa-spin'/> :
                            data.type === 'user' ? t('Next step'): 'ثبت و مرحله بعد'
                    }
                </button>
                </div>
            )}
            {(step === 2 
            //|| (step === 0 && data.type === 'expert')
            ) &&(
                <div className='text-center'>
                <button className={`btn btn-circle btn-white-purple w-50 mt30 ${step === 2 ? 'profile-step active' : 'profile-step'}`} disabled={loading && 'disabled'}
                        onClick={() => data.type === 'user' ? submit() : toast(t('تصاویر با موفقیت ثبت شد.'))}>
                    {
                        loading ?
                            <i className='fas fa-spinner fa-spin'/> :
                            data.type === 'user' ? t('Submit') : 'ثبت تصاویر'
                    }
                </button>
                </div>
            )}
            </>
            }
        </div>
        </>
    );

}
